export const numberFmt = (num: number, currency?: boolean): string => {
  let decimals = 0

  if (Math.abs(num) < 10) {
    decimals = 1
  } else if (Math.abs(num) >= 1000000 && Math.abs(num) < 10000000) {
    decimals = 2
  } else if (Math.abs(num) >= 10000000) {
    decimals = 1
  }

  if (currency && Math.abs(num) < 1000) {
    decimals = 2
  }

  return num.toLocaleString("en-US", {
    notation: Math.abs(num) >= 100000 ? "compact" : "standard",
    maximumFractionDigits: decimals,
    minimumFractionDigits: currency ? decimals : 0,
  })
}
